import { render, staticRenderFns } from "./ChangeResellerWizard.vue?vue&type=template&id=6f17c96d&scoped=true"
import script from "./ChangeResellerWizard.vue?vue&type=script&lang=js"
export * from "./ChangeResellerWizard.vue?vue&type=script&lang=js"
import style0 from "./ChangeResellerWizard.vue?vue&type=style&index=0&id=6f17c96d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f17c96d",
  null
  
)

export default component.exports